import Vue from 'vue';
import _ from 'lodash';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { ApiClient } from 'ca-api-client';

window.ca = window.ca || {};

Sentry.init({
    ...ca.sentry,
    normalizeDepth: 5,
    integrations: [
        new Integrations.ReportingObserver(),
        new Integrations.Vue({ Vue, attachProps: true, logErrors: true }),
    ],
});

Sentry.configureScope((scope) => {
    scope.setExtra('ca', window.ca);
});

window.Vue = Vue;

window.Sentry = Sentry;

Vue.prototype.$sentry = Sentry;

window._ = _;

window.select2 = require('select2');
window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');

import moment from 'moment';
window.moment = moment;

import { DateTime, Duration } from 'luxon';
window.DateTime = DateTime;

import axios from 'axios';
// Global error handler
axios.interceptors.response.use(
    (response) => {
        // can do something with successfully response globally here
        return response;
    },
    (error) => {
        let captureError = false;
        let hasResponse = false;
        const ignoreErrors = ca.config('media.http.ignore_error_codes'); // don't capture these error codes

        if (error.response) {
            // The request was made and the api responded with a status code
            // that falls out of the range of >= 200 && status < 300
            hasResponse = true;
            if (!ignoreErrors.includes(error.response.status)) captureError = true;
        } else if (error.request) {
            // The request was made but no response was received
            captureError = true;
        } else {
            // Something happened in setting up the request that triggered an Error
            captureError = true;
        }

        if (captureError) {
            Sentry.withScope((scope) => {
                if (hasResponse) scope.setExtra('response', error.response);
                Sentry.captureException(error);
            });
        }

        // pass error on to promise chain
        return Promise.reject(error);
    }
);
window.axios = axios;

/**
 * Ziggy routing - expose routes to javascript
 *
 * @todo: configure routes that are exposed
 */
import { Ziggy } from './ziggy';
import route from '../../vendor/tightenco/ziggy/src/js/route';
window.Ziggy = Ziggy;

window.route = route;

import ClipboardJS from 'clipboard';
window.ClipboardJS = ClipboardJS;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
import Echo from 'laravel-echo';
window.Echo = Echo;
import io from 'socket.io-client';
window.io = io;

// Sweetalert2
import Swal from 'sweetalert2/dist/sweetalert2.js';
window.Swal = Swal;

import * as intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils.js';
window.intlTelInput = intlTelInput;

import flatpickr from 'flatpickr';

import daterangepicker from 'daterangepicker';
import 'daterangepicker/daterangepicker.css';

import 'bootstrap-colorpicker';

import 'bootstrap-toggle';
import 'bootstrap-toggle/css/bootstrap-toggle.css';

import { v4 as uuidv4 } from 'uuid';
window.uuid = uuidv4;

import * as Filepond from 'filepond';

import FilepondPluginImagePreview from 'filepond-plugin-image-preview';
import FilepondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageSizeMetadata from '@/components/media/upload/adapters/filepond-plugin-image-size-metadata';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginFileEncode from '@/components/media/upload/adapters/filepond-plugin-file-encode';

Filepond.registerPlugin(
    FilePondPluginImageExifOrientation, // needs to be registered first
    FilepondPluginImagePreview,
    FilepondPluginFileValidateType,
    FilePondPluginImageTransform,
    FilePondPluginFileEncode,
    FilePondPluginImageSizeMetadata
);
window.Filepond = Filepond;

import mapboxgl from 'mapbox-gl';
window.mapboxgl = mapboxgl;
mapboxgl.accessToken = ca.services ? ca.services.mapbox.token : null;

/**
 * Simple detection for if the browser is a touch screen device or not
 */
if ('ontouchstart' in window || 'ontouch' in window) {
    document.body.classList.add('touch-device');
} else {
    document.body.classList.add('non-touch-device');
}

window.ca.user = window.ca.user || {};
window.ca.loginExpired = false;

let csrfToken = document.head.querySelector('meta[name="csrf-token"]');
/*if (!csrfToken && localStorage.getItem('csrfToken')) {
    csrfToken = localStorage.getItem('csrfToken');
}*/
let apiToken = document.head.querySelector('meta[name="api-token"]');
/*if (!apiToken && localStorage.getItem('apiToken')) {
    apiToken = localStorage.getItem('apiToken');
}*/

/**
 * AJAX/AXIOS Setup
 * TODO: move axios to webpack globals
 */
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if (window.ca.ignoreLogin !== true) {
    if (typeof csrfToken !== 'undefined' && csrfToken !== null && csrfToken.content.length) {
        localStorage.setItem('csrfToken', csrfToken.content);
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': csrfToken.content,
            },
        });

        // @todo: deprecate x-csrf-token in axios headers
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
    } else {
        ca.loginExpired = true;
        window.Sentry.captureMessage('NO CSRF-TOKEN found in head meta tags.');
    }

    if (typeof apiToken !== 'undefined' && apiToken !== null && apiToken.content.length) {
        ca.user.token = apiToken.content;
        localStorage.setItem('apiToken', apiToken.content);

        let authHeader = 'Bearer ' + apiToken.content;

        if (ca.api && ca.api.basic_auth) {
            if (ca.api.basic_auth.enabled) {
                authHeader = 'Basic ' + window.btoa(ca.api.basic_auth.username + ':' + ca.api.basic_auth.password);
                window.axios.defaults.headers.common['X-Access-Token'] = apiToken.content;
            }
        }

        window.axios.defaults.headers.common['Authorization'] = authHeader;
    } else {
        ca.loginExpired = true;
        window.Sentry.captureMessage('NO API-TOKEN found in head meta tags.');
    }
}

if (typeof apiToken !== 'undefined' && apiToken !== null && apiToken.content.length) {
    ca.user.token = apiToken.content;
    localStorage.setItem('apiToken', apiToken.content);

    let authHeader = 'Bearer ' + apiToken.content;
    console.log('trace a');
    if (ca.api && ca.api.basic_auth) {
        if (ca.api.basic_auth.enabled) {
            authHeader = 'Basic ' + window.btoa(ca.api.basic_auth.username + ':' + ca.api.basic_auth.password);
            window.axios.defaults.headers.common['X-Access-Token'] = apiToken.content;
            console.log('trace ab');
        }
    }

    window.axios.defaults.headers.common['Authorization'] = authHeader;
}

/**
 * Global ca helpers
 */

import confirm from '@/modules/confirm';
window.ca.confirm = confirm;

import notify from '@/modules/notify';
window.ca.notify = notify;

import config from '@/modules/config';
window.ca.config = config;

// api client config
const apiClient = new ApiClient(window.ca);
window.apiClient = apiClient;
